import React from "react";
import Notes from "./Notes";
import Addnote from "./Addnote";
export default function Home() {
  return (
    <div>
      <h1 className="mb-4 text-center">Welcome to iNotebook</h1>
      <h4 className="mb-4 text-center" style={{ color: "#6366f1" }}>
        Your Personal Cloud Notes App
      </h4>
      <Notes />
    </div>
  );
}
